import React from 'react';
import styled from 'styled-components';

import { createCollecticon } from '../collecticon-creator';

export const CollecticonTriangleRightSmall = styled(
  createCollecticon((props) => (
    <svg {...props}>
      <title>{props.title || 'triangle right small icon'}</title>
      <polygon points='11,8 6,13 6,3' />
    </svg>
  ))
)`
  /* icons must be styled-components */
`;
